module.exports = __webpack_public_path__ + "static/media/04-A-Crime-On-Your-Hands.e404f13f.m4a";